export const checkHttpUrl = (url: string) => {
	if (/(http(s?)):\/\//i.test(url)) return url;
	return `https://${url}`;
};
